import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-visation-modal',
  templateUrl: './visation-modal.component.html',
  standalone: true,
  imports: [
    CommonModule, // Para directivas como *ngIf y *ngFor
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
  ],
})
export class VisationModalComponent implements OnInit {
  visationForm: FormGroup;
  selectedFileName: string | null = null;
  selectedFileBase64: string | null = null;

  // Variables que se inyectarán desde el componente que abra el modal
  title: string = 'Título por defecto';
  description: string = 'Descripción por defecto';
  cancelButtonText: string = 'Cancelar';
  submitButtonText: string = 'Enviar';
  fields: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<VisationModalComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any, // Inyectamos los datos recibidos al abrir el modal
  ) {
    this.visationForm = this.fb.group({});
  }

  ngOnInit(): void {
    // Asignar los valores pasados a través de MAT_DIALOG_DATA a las variables locales
    if (this.data) {
      this.title = this.data.title || this.title;
      this.description = this.data.description || this.description;
      this.cancelButtonText = this.data.cancelButtonText || this.cancelButtonText;
      this.submitButtonText = this.data.submitButtonText || this.submitButtonText;
      this.fields = this.data.fields || [];

      // Añadimos dinámicamente los controles al formulario basado en los campos
      this.fields.forEach(field => {
        const validators = field.required ? [Validators.required] : [];
        // Si el campo tiene un valor inicial (por ejemplo, visationData.effectiveDate), lo establecemos
        const fieldValue = field.value || ''; // Agregar valor si está presente
        this.visationForm.addControl(field.name, this.fb.control(fieldValue, validators));
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.visationForm.valid) {
      const formData = this.visationForm.value;

      // Adjuntar el archivo en Base64 si está presente
      if (this.selectedFileBase64) {
        formData.fileBase64 = this.selectedFileBase64;
        formData.fileName = this.selectedFileName;
      }

      // Cierra el modal y devuelve los datos al componente padre
      this.dialogRef.close(formData);
    }
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFileName = file.name; // Guardar el nombre original del archivo

      // Convertir el archivo a Base64
      const reader = new FileReader();
      reader.onload = () => {
        this.selectedFileBase64 = (reader.result as string).split(',')[1]; // Extraer el Base64
      };
      reader.readAsDataURL(file);
    }
  }
}
